<script setup>
import { Toggle, Tabs, Tab, Button, Icon, Dropdown } from '@components'
import { ref, reactive, computed, onMounted } from 'vue'

// Stores.
import { useNotification } from '@store/notification'
const $notification = useNotification()

import { useSettings } from '@store/settings'
const $settings = useSettings()

const state = reactive({
    loading: false
})

onMounted(() => {
    $notification.fetchNotifications()
})

const emailChanged = async () => {
    $notification.updateNotification()
}
</script>

<template>
    <div class="my-[-28px] md:max-w-[992px] m-auto">
        <Tabs default="email" :class="{ 'pointer-events-none': state.loading }" design="underline">
            <Tab id="email">Email Notification</Tab>
            <!-- <Tab id="whatsapp">WhatsApp Notification</Tab> -->

            <!-- email  -->
            <template #email>
                <!-- Appointment notification -->
                <div class="text-2xl text-[#101828] font-semibold py-2 mb-7 capitalize">{{ $settings.labels.appointment?.singular }} notification</div>

                <div class="flex flex-wrap gap-5">
                    <!-- <div class="cursor-pointer h-[196px] w-[317px] text-[#7F56D9] text-center p-6 rounded-lg border border-[#EAECF0] flex flex-col items-center justify-center">
                        <Icon name="plus" size="56px" class=" p-3.5 bg-[#F4EBFF] rounded-full mb-2"></Icon>
                        <p class="text-xl font-semibold">Create notification</p>
                    </div> -->

                    <div v-for="(email, email_id) in $notification.getNotifications.emails" :key="email_id" class="h-[196px] w-[317px] p-6 rounded-lg border border-[#EAECF0] flex flex-col justify-between">
                        <div class="flex items-center justify-between gap-3">
                            <p class="text-[#101828] text-lg font-semibold capitalize">{{ String(email.title).replace('Appointment', $settings.labels.appointment?.singular) }}</p>
                            <Toggle v-model="email.enabled" @change="emailChanged" />
                        </div>

                        <div class="flex items-center justify-between">
                            <Button classButton="!px-6" type="secondary_gray" size="sm" radius="square" @click="$router.push({ name: 'notification.edit', params: { notificationId: email_id } })">Edit</Button>

                            <Dropdown contentClass="w-56 top-[35px] right-0 w-[117px] z-[9]">
                                <Icon name="dotsVertical" size="28px" class="text-[#98A2B3] rounded hover:bg-[#F2F4F7]" />

                                <template #content>
                                    <div class="flex flex-col gap-1">
                                        <div class="rounded-md mx-1.5 my-0.5 transition">
                                            <router-link v-if="access('notification.edit')" :to="{ name: 'notification.edit', params: { notificationId: email_id } }" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                <Icon size="16px" name="edit05" />
                                                <div class="text-[#344054] text-sm font-medium">Edit</div>
                                            </router-link>
                                        </div>
                                        <!-- <div class="rounded-md mx-1.5 my-0.5 transition">
                                            <div class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                <Icon size="16px" name="trash01" />
                                                <div @click="$notification.deleteNotification(notification.id)" class="text-[#344054] text-sm font-medium">Delete</div>
                                            </div>
                                        </div> -->
                                    </div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                <!-- Other notification -->
                <!-- <div class="text-2xl text-[#101828] font-semibold py-2 my-7">Other notification</div> -->

                <!-- <div class="cursor-pointer h-[196px] w-[317px] text-[#7F56D9] text-center p-6 rounded-lg border border-[#EAECF0] flex flex-col items-center justify-center">
                    <Icon name="plus" size="56px" class=" p-3.5 bg-[#F4EBFF] rounded-full mb-2"></Icon>
                    <p class="text-xl font-semibold">Create notification</p>
                </div> -->
            </template>
        </Tabs>
    </div>
</template>

<style>

</style>